<template>
  <div class="case-error-message-page col-block" :style="{ 'min-height': '200px' }">
    <div :style="{ flex: 1 }"></div>
    <div
      class="message-title"
      :class="[project.state.replace('created', '') || caseState, { error: project.error }]"
      :style="customContent.style || {}"
      v-html="customContent.text || ({
        uploading: [
          $t('COMPONENT.case.errorMessage.___uploading')
        ],
        analyzing: [
          $t('COMPONENT.case.errorMessage.___analyzing')
        ],
        started: [
          $t('COMPONENT.case.errorMessage.___analyzing')
        ],
        failed: !project.error ? [
          $t('COMPONENT.case.errorMessage.___failed01'),
          $t('COMPONENT.case.errorMessage.___failed02')
        ] : [
          '<span>' + $t('COMPONENT.case.errorMessage.___failed03') + '<span>',
          project.error
        ]
      }[project.state.replace('created', '') || caseState] || []).join('<br>')"
    ></div>
    <div :style="{ flex: 1 }"></div>
  </div>
</template>

<script>
export default {
  props: {
    caseState: {
      type: String,
      default: () => ''
    },
    project: {
      type: Object,
      default: () => {}
    },
    minHeight: {
      type: String,
      required: true
    },
    customContent: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/errorMessage.vue